import { render, staticRenderFns } from "./wobkBatchPrint.vue?vue&type=template&id=70a416a8&scoped=true"
import script from "./wobkBatchPrint.vue?vue&type=script&lang=js"
export * from "./wobkBatchPrint.vue?vue&type=script&lang=js"
import style0 from "./wobkBatchPrint.vue?vue&type=style&index=0&id=70a416a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a416a8",
  null
  
)

export default component.exports